import { render, staticRenderFns } from "./do_create.vue?vue&type=template&id=6e185d3a&scoped=true&"
import script from "./do_create.vue?vue&type=script&lang=js&"
export * from "./do_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e185d3a",
  null
  
)

export default component.exports